module.exports = __webpack_public_path__ + "static/mobile-6a512deac0ba9f6df7bca2fb60ddf4dd.svg";